import { Observable } from 'rxjs';
import { push } from 'react-router-redux';
import { startSubmit, stopSubmit } from 'redux-form/immutable';
import _ from 'lodash';
import { ActionsObservable } from 'redux-observable';
import { Store } from 'redux';

import VolunteersApi from 'entities/volunteers/api';
import LocationsApi from 'entities/location/api';
import { selectLocations } from 'entities/location/selectors';
import { showMessageAction, showErrorAction } from 'containers/Notification/actions';

import {
  initSuccessAction,
  initFailedAction,
  saveSuccessAction,
  saveFailedAction,
  initAction,
  saveAction,
} from './actions';
import { INIT, FORM_IDENTIFIER, SAVE } from './constants';

const init = (action$: ActionsObservable<ReturnType<typeof initAction>>, store: Store) =>
  action$.ofType(INIT).exhaustMap(() => {
    const actions = [];
    const state = store.getState();
    const locations = selectLocations(state);
    if (locations.size === 0) {
      actions.push(LocationsApi.fetchAll());
    }

    return Observable.combineLatest(actions)
      .mergeMap((resultingActions) => [..._.flatten(resultingActions), initSuccessAction()])
      .catch((e) => Observable.of(initFailedAction(e)));
  });

const save = (action$: ActionsObservable<ReturnType<typeof saveAction>>) =>
  action$.ofType(SAVE).mergeMap((payload) => {
    const data = { ...payload.data };

    return Observable.concat(
      Observable.of(startSubmit(FORM_IDENTIFIER)),
      Observable.from(
        VolunteersApi.create({
          fullName: {
            first: data.firstName,
            last: data.lastName,
          },
          email: data.email,
          phone: data.phoneNumber,
          organizationDepartment: data.department,
          location: data.location,
          organization: data.organization,
          status: 'accepted',
        })
      )
        .mergeMap((action) => [
          action,
          saveSuccessAction(),
          stopSubmit(FORM_IDENTIFIER),
          showMessageAction('Changes Saved!'),
          push(`/volunteers`),
        ])
        .catch((e) =>
          Observable.of(
            saveFailedAction(e, 'saveFailed'),
            stopSubmit(FORM_IDENTIFIER),
            showErrorAction('An error occurred during saving, please try again.')
          )
        )
    );
  });

export default [init, save];
